import React, {Fragment} from 'react';

import {Stack, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {UnitCard} from 'presentation/modules/booking/shared/ui/components/UnitCard';

import {UnitNetworkHeader} from 'presentation/modules/booking/shared/ui/components/UnitNetworkHeader';
import {translations} from 'presentation/translations-new';
import {useExamUnitsSelfNetwork} from './hooks/useExamUnitsSelfNetwork';
import {StyledButton} from './styles';
import {ExamUnitsSelfNetworkProps} from './types';
import {EmptySelfNetworkAlert} from 'presentation/modules/booking/shared/ui/components/EmptySelfNetworkAlert';

const {selfNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function ExamUnitsSelfNetwork({handleNextStep, unitsList}: ExamUnitsSelfNetworkProps) {
	const {
		listByDistanceIsEmpty,
		listByLocalityIsEmpty,
		showUnitsByDistanceTitle,
		unitsByDistanceTitle,
		handleSelectCard,
		filterIsActive,
		openDrawerButtonLabel,
		handleOpenDrawer,
		isMobile,
		query,
		specialtyName,
		hideComponent,
		getEmptyAlertDescription,
		showEmptyAlert,
		shouldHideDrawerButton,
	} = useExamUnitsSelfNetwork({handleNextStep, unitsList});

	if (hideComponent) return null;

	return (
		<Stack gap={2}>
			{showEmptyAlert ? (
				<EmptySelfNetworkAlert description={getEmptyAlertDescription()} />
			) : (
				<Fragment>
					<UnitNetworkHeader
						title={selfNetwork.title}
						description={selfNetwork.onlineScheduleExamDescription}
					/>

					{listByLocalityIsEmpty ? null : (
						<Grid container spacing={2}>
							{unitsList?.units?.unitsByLocality?.map(unit => {
								return (
									<Grid
										key={`${unit.name}-${unit.formattedAddress}`}
										size={{xs: isMobile ? 12 : 6}}>
										<UnitCard
											query={query}
											isNotSelf={false}
											onClick={() =>
												handleSelectCard({
													code: unit?.code,
													address: unit?.formattedAddress,
													name: unit?.name,
												})
											}
											unitName={unit?.name}
											address={unit?.formattedAddress}
											nmBairroOrigem={unit?.nmBairroOrigem}
											isTelemedicine={false}
											distanceReference={unit?.distance}
											specialtyName={specialtyName}
										/>
									</Grid>
								);
							})}
						</Grid>
					)}

					{listByDistanceIsEmpty ? null : (
						<Fragment>
							{showUnitsByDistanceTitle() ? (
								<Typography
									variant="subtitle2"
									color="text.secondary"
									lineHeight={1.75}>
									{unitsByDistanceTitle}
								</Typography>
							) : null}

							<Grid container spacing={2}>
								{unitsList?.units?.unitsByDistance?.map(unit => {
									return (
										<Grid
											key={`${unit.name}-${unit.formattedAddress}`}
											size={{xs: isMobile ? 12 : 6}}>
											<UnitCard
												query={query}
												showDistanceReference
												isNotSelf={false}
												onClick={() =>
													handleSelectCard({
														code: unit?.code,
														address: unit?.formattedAddress,
														name: unit?.name,
													})
												}
												unitName={unit?.name}
												address={unit?.formattedAddress}
												nmBairroOrigem={unit?.nmBairroOrigem}
												isTelemedicine={false}
												distanceReference={unit?.distance}
												specialtyName={specialtyName}
											/>
										</Grid>
									);
								})}
							</Grid>
						</Fragment>
					)}
				</Fragment>
			)}

			{shouldHideDrawerButton ? null : (
				<StyledButton
					data-tag-id={
						filterIsActive
							? AppointmentBookingEnum.ALTEROU_DISTANCIA
							: AppointmentBookingEnum.PROCUROU_UNIDADES_PROXIMAS
					}
					variant="outlined"
					size="large"
					onClick={handleOpenDrawer}>
					{openDrawerButtonLabel()}
				</StyledButton>
			)}
		</Stack>
	);
}
